var map = {
	"./blg-en-mfilter/assets/cross-sell-banner.png": 8,
	"./blg-en/assets/cross-sell-banner.png": 864,
	"./brain-spark-en-mfilter/assets/cross-sell-banner.png": 625,
	"./fantasy-soccer-en/assets/cross-sell-banner.png": 585,
	"./game-rush-mfilter/assets/cross-sell-banner.png": 808,
	"./gameapp-world-en/assets/cross-sell-banner.png": 993,
	"./rush-games-en/assets/cross-sell-banner.png": 987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 942;